import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { Header } from '../components/Header';
import { getSession } from '../services/apis';

const PrivateRoute = () => {
    const [isTokenValid, setIsTokenValid] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const verifyToken = async () => {
            try {
                await getSession();
                setIsTokenValid(true);
            } catch (error) {
                console.error('Error verifying token:', error);
                setIsTokenValid(false);
                localStorage.clear();
            }
        };

        verifyToken();
    }, [location]);

    if (isTokenValid === null) {
        return <div><CircularProgress /></div>;
    }

    return isTokenValid
        ? (
            <>
                <Header />
                <Outlet />
            </>
        )
        : <Navigate to="/login" />;
};

export default PrivateRoute;
